import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { AppSnackbar, ConfirmDialog } from '@sierralabs/core-ui';
import { AlertDialog } from '@sierralabs/react-material-ui';
import { usePublishFormTemplate, useUpdateFormTemplate } from '../FormTemplate.hooks';
import { FormTemplateStatus } from '../FormTemplate.interface';
import { StateNodeType } from '@sierralabs/state-machine';
const FormTemplateStatusActions = ({ formTemplate, elementPlugins, onChange }) => {
    // const [openRevertDialog, setOpenRevertDialog] = useState(false);
    const [openPublishDialog, setOpenPublishDialog] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const { updatedFormTemplate, isUpdating, updateFormTemplate } = useUpdateFormTemplate(formTemplate.id);
    const { publishedFormTemplate, isPublishing, publishError, publishFormTemplate } = usePublishFormTemplate(formTemplate.id);
    const onChangeRef = useRef(onChange);
    useEffect(() => {
        if (updatedFormTemplate && onChangeRef && onChangeRef.current) {
            onChangeRef.current(updatedFormTemplate);
        }
    }, [updatedFormTemplate]);
    useEffect(() => {
        if (publishedFormTemplate && onChangeRef && onChangeRef.current) {
            onChangeRef.current(publishedFormTemplate.formTemplate);
        }
    }, [publishedFormTemplate]);
    switch (formTemplate.status) {
        case FormTemplateStatus.Draft:
            return (React.createElement(Fragment, null,
                React.createElement(Button, { variant: 'contained', color: 'secondary', endIcon: isPublishing && React.createElement(CircularProgress, { size: 16 }), onClick: () => {
                        var _a, _b, _c;
                        let hasFinal = false;
                        for (const stateNode of ((_a = formTemplate.config) === null || _a === void 0 ? void 0 : _a.states) || []) {
                            for (const element of ((_b = stateNode.meta) === null || _b === void 0 ? void 0 : _b.elements) || []) {
                                const plugin = elementPlugins === null || elementPlugins === void 0 ? void 0 : elementPlugins.find(p => p.type === element.type);
                                // for html elements check if editable
                                const requiresDataSource = (plugin === null || plugin === void 0 ? void 0 : plugin.type) === 'Html' && !((_c = element.config) === null || _c === void 0 ? void 0 : _c.editable)
                                    ? false
                                    : plugin === null || plugin === void 0 ? void 0 : plugin.dataTypes;
                                if (requiresDataSource && !element.dataSource) {
                                    setAlertMessage(`Field: "${element.title}" is missing a Data field configuration. You need to specify a field to store the data captured on the form.`);
                                    return;
                                }
                                if (stateNode.type === StateNodeType.Final) {
                                    hasFinal = true;
                                }
                            }
                        }
                        if (!hasFinal) {
                            setAlertMessage('You are missing a "Final" section type. This tells the system that the form has been completed when the user lands on that section.');
                            return;
                        }
                        setOpenPublishDialog(true);
                    } }, "Publish"),
                publishError && (React.createElement(AppSnackbar, { open: true, severity: 'error' },
                    "Error publishing: ",
                    publishError.message)),
                alertMessage && (React.createElement(AlertDialog, { open: true, title: 'Form Correction Needed', message: alertMessage, onClose: () => setAlertMessage('') })),
                openPublishDialog && (React.createElement(ConfirmDialog, { open: openPublishDialog, title: `Publish version: ${formTemplate.version}`, message: `Are you sure you want to publish ${formTemplate.name} version: ${formTemplate.version}? Your changes will be permanent.`, onCancel: () => {
                        setOpenPublishDialog(false);
                    }, onConfirm: () => {
                        setOpenPublishDialog(false);
                        publishFormTemplate();
                    } })),
                updatedFormTemplate && (React.createElement(AppSnackbar, { open: true, severity: 'success' }, "Started new draft"))));
        case FormTemplateStatus.Published:
            return (React.createElement(Fragment, null,
                React.createElement(Button, { variant: 'contained', color: 'secondary', endIcon: isUpdating && React.createElement(CircularProgress, { size: 16 }), onClick: () => updateFormTemplate({ status: FormTemplateStatus.Draft }) }, "Start New Draft"),
                publishedFormTemplate && (React.createElement(AppSnackbar, { open: true, severity: 'success' }, "Form published"))));
        default:
            return null;
    }
};
export default FormTemplateStatusActions;
//# sourceMappingURL=FormStatusActions.js.map